import {

  EodMelcoEodModelsEodSetting,
  EodSettingsApi,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { isEmpty } from "lodash-es";

export const useEodSettings = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<EodMelcoEodModelsEodSetting>();

  const query = useAPIQuery(
    EodSettingsApi,
    ["eodSettings", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      let response = await api.eodSearchSettings({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });
      setTotal(response.total);

      // return response.list;
      // let response = {
      //   "list": [{
      //     "name": "ABC",
      //     "partner": "XYZ",
      //     "auth": "auth",
      //     "url": "http://abc.com",
      //     "created_date": new Date("2025-11-27T01:45:43.851Z"),
      //     "last_activity": new Date("2025-11-27T01:45:43.851Z")
      //   }]
      // }
      console.log("RESPONSE IS ", JSON.stringify(response))

      return response.list;
    },
    {

    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
